window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 0;
window.lazySizesConfig.expFactor = 1;
window.lazySizesConfig.loadMode = 1;